<div class="top-title-filter">
    <h1 class="title">
        Insights
    </h1>
    <div class="d-flex gap-2 flex-wrap">
        <p-datepicker styleClass="campaign-date-filter" placeholder="Pick a date" [showIcon]="true" />
        <button pButton class="custom-btn blue-border" icon="pi pi-download">
            Export
        </button>
    </div>
</div>

<div class="cards-container mt-4">
    <p-card>
        <div class="d-flex justify-content-between gap-2 align-items-center ">
            <div class="d-flex flex-column gap-1">
                <h1 class="disable-label">
                    Total Spent
                </h1>
                <span class="value">
                    40,689 SAR
                </span>
            </div>
            <img class="blue" src="../../../../../assets/icons/invoice.svg" alt="">
        </div>
        <p>
            <span class="text-green">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M16 6L18.29 8.29L13.41 13.17L9.41 9.17L2 16.59L3.41 18L9.41 12L13.41 16L19.71 9.71L22 12V6H16Z"
                        fill="#00B69B" />
                </svg>
                8.5%
            </span>
            Up from yesterday
        </p>
    </p-card>
    <p-card>
        <div class="d-flex justify-content-between gap-2 align-items-center ">
            <div class="d-flex flex-column gap-1">
                <h1 class="disable-label">
                    Total Spent
                </h1>
                <span class="value">
                    40,689 SAR
                </span>
            </div>
            <img src="../../../../../assets/icons/windows-icon.PNG" alt="">
        </div>
        <p>
            <span class="text-green">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M16 6L18.29 8.29L13.41 13.17L9.41 9.17L2 16.59L3.41 18L9.41 12L13.41 16L19.71 9.71L22 12V6H16Z"
                        fill="#00B69B" />
                </svg>
                8.5%
            </span>
            Up from yesterday
        </p>
    </p-card>
    <p-card>
        <div class="d-flex justify-content-between gap-2 align-items-center ">
            <div class="d-flex flex-column gap-1">
                <h1 class="disable-label">
                    Conversions
                </h1>
                <span class="value">
                    34
                </span>
            </div>
            <img src="../../../../../assets/icons/orange-box.svg" alt="">
        </div>
        <p>
            <span class="text-green">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M16 6L18.29 8.29L13.41 13.17L9.41 9.17L2 16.59L3.41 18L9.41 12L13.41 16L19.71 9.71L22 12V6H16Z"
                        fill="#00B69B" />
                </svg>
                8.5%
            </span>
            Up from past week
        </p>
    </p-card>
    <p-card>
        <div class="d-flex justify-content-between gap-2 align-items-center ">
            <div class="d-flex flex-column gap-1">
                <h1 class="disable-label">
                    Amount Spent
                </h1>
                <span class="value">
                    40,689 SAR
                </span>
            </div>
            <img src="../../../../../assets/icons/green-line.svg" alt="">
        </div>
        <p>
            <span class="text-green">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M16 6L18.29 8.29L13.41 13.17L9.41 9.17L2 16.59L3.41 18L9.41 12L13.41 16L19.71 9.71L22 12V6H16Z"
                        fill="#00B69B" />
                </svg>
                8.5%
            </span>
            Up from yesterday
        </p>
    </p-card>
</div>


<p-card class="card-container mt-4">
    <h1 class="card-title">
        Total Spent
    </h1>
    <p-chart type="line" [data]="totalSpendBalanceData" [options]="lineOptions" height="60vh" />
</p-card>

<p-card class="card-container mt-4">
    <h1 class="card-title">
        Impressions VS Clicks
    </h1>
    <p-chart type="bar" [data]="barChartData" [options]="barChartOptions" class="h-[30rem]" />
</p-card>

<div class="two-cards mt-4">
    <p-card class="card-container">
        <h1 class="card-title">
            Top Locations
        </h1>
        <div class="location-item" *ngFor="let location of locations">
            <div class="location-header">
                <span class="location-name">{{ location.name }}</span>
            </div>
            <div class="d-flex gap-2 flex-wrap align-items-center">
                <p-progressBar [value]="location.percentage" [showValue]="false" styleClass="custom-progress">
                </p-progressBar>
                <span class="location-percentage">{{ location.percentage }} %</span>
            </div>
        </div>
    </p-card>
    <p-card class="card-container">
        <h1 class="card-title">
            Ad Placements
        </h1>
        <div class="placement" *ngFor="let device of devices">
            <div class="location-header">
                <img [src]="device?.img" alt="" class="me-2">
                <span class="location-name">{{ device.name }}</span>
            </div>
            <div class="d-flex gap-2 flex-wrap align-items-center">
                <span class="percentage">{{ device.percentage }} %</span>
            </div>
        </div>
    </p-card>
</div>